const data = [
  {
    id: 1,
    name: "Russel",
    jd: "Front-end Developer",
    profile: "https://images.pexels.com/photos/1376201/pexels-photo-1376201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    reminder: "Work on our main site",
  },
  {
    id: 2,
    name: "Peter",
    jd: "Back-end Developer",
    profile: "https://images.pexels.com/photos/1785283/pexels-photo-1785283.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    reminder: "Fix the back-end of our main site",
  },
  {
    id: 3,
    name: "John",
    jd: "UI designer",
    profile: "https://images.pexels.com/photos/3225529/pexels-photo-3225529.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    reminder: "Design our main site",
  },
  {
    id: 4,
    name: "Brad",
    jd: "Front-end Intern",
    profile: "https://images.pexels.com/photos/4344427/pexels-photo-4344427.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    reminder: "Create a site and give it some styles",
  },
  {
    id: 5,
    name: "Ivan",
    profile: "https://images.pexels.com/photos/5708073/pexels-photo-5708073.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    jd: "Full Stack Javascript developer",
    reminder: "Build a web app for the company",
  },
];

export default data;
